<template>

    <rkm-row>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.circunferenciaAbdominal"
                append="cm"
                label="Circunferência abdominal"
                placeholder="000"
                v-mask="masks.circunferenciaAbdominal"
                v-model="model.medicoes.circunferenciaAbdominal"
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.perimetroPanturrilha"
                append="cm"
                label="Perímetro da panturrilha"
                placeholder="00"
                v-mask="masks.perimetroPanturrilha"
                v-model="model.medicoes.perimetroPanturrilha"
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.pressaoArterial"
                label="Pressão arterial"
                placeholder="000/000"
                v-mask="'###/###'"
                v-model="model.medicoes.pressaoArterial"
            >
                <rkm-input-group-append slot="append">
                    <rkm-input-group-text>
                        mmHg
                    </rkm-input-group-text>
                </rkm-input-group-append>
            </rkm-form-input>
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.frequenciaRespiratoria"
                label="Frequência respiratória"
                placeholder="000"
                v-mask="'###'"
                v-model="model.medicoes.frequenciaRespiratoria"
            >
                <rkm-input-group-append slot="append">
                    <rkm-input-group-text>
                        mpm
                    </rkm-input-group-text>
                </rkm-input-group-append>
            </rkm-form-input>
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.frequenciaCardiaca"
                label="Frequência cardíaca"
                placeholder="000"
                v-mask="'###'"
                v-model="model.medicoes.frequenciaCardiaca"
            >
                <rkm-input-group-append slot="append">
                    <rkm-input-group-text>
                        bpm
                    </rkm-input-group-text>
                </rkm-input-group-append>
            </rkm-form-input>
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.temperatura"
                label="Temperatura"
                placeholder="00,0"
                v-mask="'##.#'"
                v-model="model.medicoes.temperatura"
            >
                <rkm-input-group-append slot="append">
                    <rkm-input-group-text>
                        °C
                    </rkm-input-group-text>
                </rkm-input-group-append>
            </rkm-form-input>
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.saturacaoO2"
                label="Saturação de O2"
                placeholder="000"
                v-mask="'###'"
                v-model="model.medicoes.saturacaoO2"
            >
                <rkm-input-group-append slot="append">
                    <rkm-input-group-text>
                        %
                    </rkm-input-group-text>
                </rkm-input-group-append>
            </rkm-form-input>
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.peso"
                append="kg"
                label="Peso"
                placeholder="000.00"
                v-mask="pesoMask"
                v-model="model.medicoes.peso"
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.altura"
                append="cm"
                label="Altura"
                placeholder="000"
                v-mask="'###'"
                v-model="model.medicoes.altura"
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.perimetroCefalico"
                append="cm"
                label="Perímetro cefálico"
                placeholder="000.0"
                v-mask="masks.perimetroCefalico"
                v-model="model.medicoes.perimetroCefalico"
            />
        </rkm-col>

        <rkm-col cols="3">
            <rkm-form-input
                :validations="validations.glicemia"
                label="Glicemia capilar"
                placeholder="000"
                v-mask="masks.glicemia"
                v-model="model.medicoes.glicemia"
            >
                <rkm-input-group-append slot="append">
                    <rkm-input-group-text>
                        mg/dL
                    </rkm-input-group-text>
                </rkm-input-group-append>
            </rkm-form-input>
        </rkm-col>

        <rkm-col>

            <rkm-form-select
                :options="form.momentosColeta"
                :validations="validations.momentoColeta"
                label="Momento da coleta"
                show-default-option
                text-field="nome"
                v-model="model.medicoes.momentoColetaId"
                default-option-text="Selecione"
                value-field="id"
                class="pt-0"
            />
        </rkm-col>
    </rkm-row>
</template>

<script>

//Enums
import procedimento from '@/enums/sigtap/procedimento'

// Mixins
import { object, formats, mask, data } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                perimetroCefalico: { min_value: 10, max_value: 200 },
                peso: { min_value: 0.5, max_value: 500 },
                altura: { min_value: 20, max_value: 250 },
                glicemia: { required: this.model.medicoes.momentoColetaId ? true : false, min_value: 0, max_value: 800 },
                momentoColeta: { required: this.model.medicoes.glicemia ? true : false },
                circunferenciaAbdominal: { max_value: 999 },
                perimetroPanturrilha: { min_value: 10, max_value: 99 },
                frequenciaRespiratoria: { min_value: 0, max_value: 200 },
                frequenciaCardiaca: {max_value: 999},
                temperatura: { min_value: 20, max_value: 45 },
                saturacaoO2: { min_value: 0, max_value: 100 },
            }
        },
        pesoMask() {

            const length = (this.model.medicoes.peso ?? '').replace('.', '').length

            if (length <= 3) {

                return '#.##'
            }
            else if (length <= 4) {

                return '##.##'
            }
            else {

                return '###.##'
            }
        },
    },
    data: () => ({
        masks: {
            altura: '###',
            circunferenciaAbdominal: '###',
            perimetroCefalico: '###.#',
            perimetroPanturrilha: '##',
            peso: '###.##',
            glicemia: '###',
        },
        enums: {
            procedimento,
        },
    }),
    methods: {
        addProcedimento(codigoProcedimento){

            const procedimento = this.form.procedimentos.find(procedimento => procedimento.codigo == codigoProcedimento)
            const existe = this.model.procedimentos.find(procedimento => procedimento.codigo == codigoProcedimento)

            if (existe || !this.hasLimit()) {
                return false
            }

            if (procedimento) {

                const param = {
                    id: procedimento.id,
                    nome: procedimento.nome,
                    codigo: procedimento.codigo,
                    origem: 'atencaoBasica',
                    quantidade: '1',
                }

                this.model.procedimentos.push(this.clone(param))
            }
        },
        removeAfericaoPressaoArterial() {

            const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                == this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)

            const pressaoArterial = this.model.medicoes.pressaoArterial

            if (index >= 0 && !pressaoArterial) {
                this.model.procedimentos.splice(index, 1)
            }
        },
        hasLimit() {
            if(this.model.procedimentos.length + Object.entries(this.model.procedimentosQuantidade).filter(p => {
                return p[1] != ''
            }).length >= 20) {
                return false
            }

            return true
        }
    },
    mixins: [ object, formats, mask, data ],
    props: {
        model: { type: Object, required: false },
        form: { type: Object, required: false }
    },
    watch: {
        'model.medicoes.pressaoArterial': function (pressaoArterial) {

            if (pressaoArterial) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            } else {

                this.removeAfericaoPressaoArterial()
            }
        },
        'model.medicoes.peso': function (peso) {

            if (peso) {
                this.addProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)

                if (this.model.medicoes.altura) {
                    this.addProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.MEDICAO_DE_PESO)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }

                const objIndex = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)

                if (objIndex >= 0) {
                    this.model.procedimentos.splice(objIndex, 1)
                }
            }
        },
        'model.medicoes.altura': function (altura) {

            if (altura) {
                this.addProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)

                if (this.model.medicoes.peso) {
                    this.addProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.MEDICAO_DE_ALTURA)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }

                const objIndex = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)

                if (objIndex >= 0) {
                    this.model.procedimentos.splice(objIndex, 1)
                }
            }
        },
        'model.medicoes.temperatura': function (febre) {

            if (febre) {
                this.addProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            } else {

                const index = this.model.procedimentos.findIndex(procedimento => procedimento.codigo
                    == this.enums.procedimento.AFERICAO_DE_TEMPERATURA)

                if (index >= 0) {
                    this.model.procedimentos.splice(index, 1)
                }
            }
        },
    }
};
</script>
